import React, { useEffect, useState } from "react";
// import InventoryTypeField from "./InventoryTypeField";
// import * as inventoryService from "./inventoryService";
//import { TableContext } from "../index";
// import InventoryTargetField from "./InventoryTargetField";
import InventoryCommandField from "./InventoryCommandField";
import ScanButton from "./ScanButton";
// import ScheduleScanButton from "./ScheduleScanButton";
//import ScanSearchSection from "./ScanSearchSection";
import InventorySearchSection from "./InventorySearchSection";

export function InventoryConfigManagement() {

    const initialState = {
        command: '',
        selectedType: null,
    }

    const [state, setState] = useState(initialState);
    const [scanStatus, setScanStatus] = useState('');

    // const [scanTypesData, setScanTypesData] = useState([]);
 

    const fetchData = async () => {
        try {
            //const nmapConfigList = await nmapService.getNmapConfigs();
            //setScanTypesData(nmapConfigList);
            //const [deviceList, deviceTypeList, msbList] = await Promise.all([deviceListPromise, deviceTypeListPromise, msbListPromise]);

            // let type;
            // const pageFilters = getFilers(true);
            // if (pageFilters.type) {
            //     type = nmapConfigList.find(type => type.type === pageFilters.type);
            // }
            // let newTableConfig = config;
            // //if (type) {
            //     newTableConfig = { ...newTableConfig, typeId: "-1" };
            //    // setTypeId(type.id);
            // //}
            // setConfig({ ...newTableConfig });

        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        fetchData();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);


    // const onTypeChange = (value, details, command) => {
    //     setState({
    //       ...state,
    //       selectedType: value,
    //       details: details,
    //       command: command,
    //     });
    //   }

    // const onTargetChange = (value) => {
    //     //let commandText = state.command;
    //     setState({
    //     ...state,
    //     target: value,
    //     //command: commandText + " " + state.target
    // });
    // };

    const onCommandChange = (value) => {
        setState({
            ...state,
            command: value
        });
    };
      

    //const isDetailsValid = () => state.details && state.details.length > 0;

    return (
        <div className="container-fluid">
            <section className="network-scan-config-v2">
                <div className="network-scan-config-header-v2">
                    <div>
                        <h2 className="network-scan-title-v2">Host Discovery</h2>
                        <p className="network-scan-subtitle-v2">Discover live hosts by scanning an IP address or subnet</p>
                    </div>
                </div>
                <form action="" className="network-scan-form-v2">
                    <div className="network-scan-form-grid-v2">
                        <div className="network-scan-field-v2--full">
                            <InventoryCommandField value={state.command}
                                onChange={onCommandChange}/>
                            <span className="network-scan-helper-v2">
                                Example: 192.168.1.1/24 or 192.168.1.1/32
                            </span>
                        </div>
                    </div>
                    <div className="network-scan-action-bar-v2">
                        <div className="network-scan-button-group-v2">
                            <ScanButton command={state.command}
                                scanStatus={scanStatus}
                                setScanStatus={setScanStatus}/>
                        </div>
                        <InventorySearchSection />
                    </div>
                </form>
            </section>
        </div>
    )
}
